import { create } from 'zustand';

import { usePlanFeatureStore } from '@/store/planFeatureStore';
import { sanitizeErrorText } from '@/utils/api-error';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  addToast: (message: string, type: ToastType, duration?: number) => void;
  removeToast: (id: number) => void;
}

const DEFAULT_DURATION = 3000;
let toastId = 0;

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  addToast: (message, type, duration = DEFAULT_DURATION) => {
    // O aviso de plano já explicou a recusa: o toast de erro do call site
    // seria o mesmo feedback duas vezes.
    if (type === 'error' && usePlanFeatureStore.getState().feature) return;
    const id = toastId++;
    // Última barreira: nenhum toast de erro pode carregar array de validação,
    // stack trace ou "HTTP 500" cru. Se algum call site esqueceu de tratar,
    // sanitizeErrorText troca por uma mensagem genérica.
    const safeMessage =
      type === 'error'
        ? sanitizeErrorText(message, 'Algo deu errado. Tente novamente.')
        : message;
    const newToast: Toast = { id, message: safeMessage, type, duration };

    set((state) => ({
      toasts: [...state.toasts, newToast],
    }));

    setTimeout(() => {
      get().removeToast(id);
    }, duration);
  },

  removeToast: (id) => {
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    }));
  },
}));

export const showToast = useToastStore.getState().addToast;
